import { Box } from "@mui/material";
import Lottie from "react-lottie";
import { useSelector } from "react-redux";
import moment from "moment-timezone";
import { isTMA, miniApp } from "@telegram-apps/sdk-react";

import Text from "./text/Text";
import {
  fromDate,
  maintenanceInfo,
  maintenanceScheduled,
  maintenanceScheduledSubMsg,
  miniAppUnderMaintenance,
  miniAppUnderMaintenanceSubMsg,
  okay,
  toDate,
} from "./messages";
import Button from "./button/Button";
import CustomDivider from "./divider/Divider";
import { logOut } from "./constants";
import maintenanceAnimation from "./animations/maintenanceAnimation.json";

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: maintenanceAnimation,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

function MaintenancePage({
  isFromBrowser,
  isUpcomingMaintenance = false,
  isUnderMaintenance = false,
  isFromMiniApp = false,
  closeDialog,
  customClass,
}) {
  const headerTextSize = isFromBrowser ? 22 : 20;
  const subHeaderTextSize = isFromBrowser ? 16 : 14;
  const infoTextSize = isFromBrowser ? 14 : 12;

  const maintenance = useSelector((state) => state.common.maintenance);

  const { maintenance_data } = { ...maintenance };

  const handleClick = () => {
    if (isFromMiniApp) {
      closeDialog?.();
    } else {
      isTMA() ? miniApp.close() : logOut();
    }
  };

  const displayDateTime = (title, date) => {
    return (
      <Box display="flex" flexDirection="column" alignItems="center">
        <Text className="grey-text" size={subHeaderTextSize} font="regular">
          {title}
        </Text>
        <Text className="default-text" size={subHeaderTextSize} font="semibold">
          {` ${moment(date).format("DD/MM/YYYY")}`}
        </Text>
        <Text
          className="default-text"
          size={subHeaderTextSize}
          font="semibold"
          sx={{ marginBottom: isFromBrowser ? "30px" : "16px" }}
        >
          {`${moment(date).format("LT")}`}
        </Text>
      </Box>
    );
  };

  const renderHeading = isFromMiniApp
    ? miniAppUnderMaintenance
    : maintenanceScheduled;

  const renderSubMessage = isFromMiniApp
    ? miniAppUnderMaintenanceSubMsg
    : maintenanceScheduledSubMsg;

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      height="100%"
    >
      <Box
        className={customClass}
        {...(isFromMiniApp && { height: "100% !important" })}
      >
        <Lottie options={defaultOptions} height="110px" width="110px" />
        <Text className="default-text mb-10" size={headerTextSize} font="bold">
          {isUpcomingMaintenance ? maintenance_data?.title : renderHeading}
        </Text>
        <Text
          className="grey-text"
          size={subHeaderTextSize}
          font="regular"
          sx={{
            marginBottom: isFromBrowser ? "30px" : "16px",
            textAlign: "center",
          }}
        >
          {isUpcomingMaintenance
            ? maintenance_data?.description
            : renderSubMessage}
        </Text>
        {isUpcomingMaintenance && (
          <>
            <Box
              display="flex"
              sx={{ ...(!isFromBrowser && { margin: "10px" }) }}
            >
              {displayDateTime(fromDate, maintenance_data?.start_time)}
              <CustomDivider
                orientation="vertical"
                sx={{ margin: isFromBrowser ? "-15px 32px" : "-8px 32px" }}
              />
              {displayDateTime(toDate, maintenance_data?.end_time)}
            </Box>

            <Text
              className="grey-text"
              size={infoTextSize}
              font="regular"
              sx={{ ...(isFromBrowser && { marginBottom: "40px" }) }}
            >
              {maintenanceInfo}
            </Text>
          </>
        )}
        {isUnderMaintenance && (
          <Button variant="contained" label={okay} onClick={handleClick} />
        )}
      </Box>
    </Box>
  );
}

export default MaintenancePage;
